import { Script } from 'gatsby'
import GlobalStyles from 'components/globalStyles'
import DesktopMenu from 'components/menu/desktopMenu'
import MobileMenu from 'components/menu/mobileMenu'
import Footer from 'components/footer/footer'
import { OuterContainer, MenuConditionalDiv } from './layout_styles'
import 'swiper/css'
import 'swiper/css/pagination'

const Layout = ({ children, $home }) =>
  <OuterContainer gap={0}>
    <GlobalStyles />
    <Script src='https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Wq5VA7' />
    <MenuConditionalDiv desktopOnly>
      <DesktopMenu />
    </MenuConditionalDiv>
    <MenuConditionalDiv mobileOnly>
      <MobileMenu $home={$home} />
    </MenuConditionalDiv>
    <main>
      {children}
    </main>
    <Footer />
  </OuterContainer>

export default Layout
